import React from "react";
import SiteGroupList from "../component/SiteGroupList";

const SiteGroupListContainer = () => (<SiteGroupList />)

export default SiteGroupListContainer;
